<template>
  <a-layout id="vueLayout">
    <a-layout-sider breakpoint="lg" collapsed-width="0">
      <div class="logo">
        <img class="img_size" src="../assets/img/zhulia-07.png" />
      </div>
      <a-menu class="top" @select="OnSelect" @click="Onchange" mode="inline">
        <a-menu-item class="overview" key="overview">
          <a-icon class="menuIcon" theme="filled" type="pie-chart" />
          <span>Overview</span>
        </a-menu-item>


        <a-sub-menu class="subReport mt-5">
          <span slot="title">
            <a-icon class="menuIcon" type="shopping" /><span>Products</span>
          </span>
          <a-menu-item key="inventory">
            <span>Main Catalog</span>
          </a-menu-item>
          <a-menu-item key="view-campaigns"> BackOrder Catalog </a-menu-item>
          <a-menu-item key="batch-management"> Batch Management </a-menu-item>
          <!-- <a-menu-item key="products-management"> Management </a-menu-item> -->
        </a-sub-menu>

        <a-sub-menu class="subReport">
          <span slot="title">
            <a-icon class="menuIcon" type="user" /><span>Pipeline</span>
          </span>
          <!-- <a-menu-item key="pipeline/dashboard"> Dashboard </a-menu-item> -->
          <a-menu-item key="pipeline/contacts"> Contacts </a-menu-item>
          <a-menu-item key="pipeline/leads"> Leads </a-menu-item>
          <!-- <a-menu-item key="pipeline/opportunities">
            <span>Opportunities</span>
          </a-menu-item> -->
          <!-- <a-menu-item key="pipeline/support"> Customer Support </a-menu-item> -->
        </a-sub-menu>


        <a-sub-menu class="subReport">
          <span slot="title">
            <a-icon class="menuIcon" type="tag" /><span>Sales</span>
          </span>
          <a-menu-item key="customers"> Account </a-menu-item>
          <a-menu-item key="invoices"> Invoices </a-menu-item>
          <a-menu-item key="payments"> Payments </a-menu-item>
          <a-menu-item key="shipments"> Shipments </a-menu-item>
          <a-menu-item key="packages"> Packages </a-menu-item>
          <a-menu-item key="orders"> Orders </a-menu-item>
          <a-menu-item key="view-back-orders">
            <span>Quotations</span>
          </a-menu-item>
          <a-menu-item key="credit-notes">
            <span>Credit Notes</span>
          </a-menu-item>

        </a-sub-menu>
        <a-sub-menu class="subReport">
          <span slot="title">
            <a-icon class="menuIcon" type="book" /><span>Inventory Controls</span>
          </span>
          <a-menu-item key="suppliers"> Suppliers </a-menu-item>
          <a-menu-item key="locations/distribution_centers">
            Warehouses
          </a-menu-item>
          <!-- purchase-order-menu -->
          <a-menu-item key="purchase-order-menu">
            <span> Purchase Orders</span>
          </a-menu-item>
          <a-menu-item key="inventory-transfer">Replenishment</a-menu-item>
          <a-menu-item key="inventory-reports"> Inventory History </a-menu-item>
          <a-menu-item key="stock-adjustment">
            Adjustment History.
          </a-menu-item>

          <!-- <a-menu-item key=""> Valuation Reports. </a-menu-item> -->
          <!-- <a-menu-item key="low-stock">
                        Low Stock
                    </a-menu-item>
                    <a-menu-item key="out-of-stock">
                        Out of Stock
                    </a-menu-item> -->
        </a-sub-menu>
        <a-sub-menu class="subReport">
          <span slot="title">
            <a-icon class="menuIcon" type="line-chart" /><span>Finance</span>
          </span>
          <a-menu-item key="report"> Daily & Monthly </a-menu-item>
          <a-menu-item key="item"> Sale By Items </a-menu-item>
          <a-menu-item key="location"> Sale By Locations</a-menu-item>
          <a-menu-item key="category"> Sale By Category</a-menu-item>
          <a-menu-item key="customer-sales"> Sale By Customer</a-menu-item>
        </a-sub-menu>
        <a-sub-menu class="subReport">
          <span slot="title">
            <a-icon class="menuIcon" type="file-text" /><span>Reports</span>
          </span>

          <a-menu-item key="waybills-reports"> Performance </a-menu-item>
          <!-- <a-menu-item key="waybills-reports">
            Waybills
          </a-menu-item>
          <a-menu-item key="purchased-order-reports">
            Purchase Orders
          </a-menu-item> -->
        </a-sub-menu>
        <!-- <a-menu-item key="users">
          <a-icon class="menuIcon" type="user" />
          <span>Users</span>
        </a-menu-item> -->

        <!-- <a-menu-item key="settings">
                    <a-icon class="menuIcon" type="setting" />
                    <span>Settings</span>
                </a-menu-item> -->
        <!-- <a-menu-item class="retail"> SUPPORT </a-menu-item>
        <a-menu-item key="help">
          <a-icon class="menuIcon" type="question-circle" />
          <span>Help</span>
        </a-menu-item> -->
        <a-sub-menu class="subReport">
          <span slot="title">
            <a-icon class="menuIcon" type="setting" /><span>Settings</span>
          </span>
          <a-menu-item key="vaccine-templates"> Vaccine Templates </a-menu-item>
          <a-menu-item key="manufacturers"> Manufacturers </a-menu-item>
          <a-menu-item key="geography/community"> Community </a-menu-item>
          <a-menu-item key="geography/regions/sub"> Sub-Regions </a-menu-item>
          <a-menu-item key="geography/regions"> Regions </a-menu-item>
          <a-menu-item key="products-management">
            Product Management
          </a-menu-item>
          <a-menu-item key="users"> User Management </a-menu-item>
        </a-sub-menu>
        <!-- <a-menu-item key="talkToHuman">
                    <a-icon class="menuIcon" type="phone" />
                    <span>Talk To Human</span>
                </a-menu-item> -->
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="background: #fff; padding: 0">
        <div style="float: right; padding-right: 18px">
          <a-dropdown style="color: #4d4f5c; margin-right: 10px" :trigger="['click']">
            <a style="text-decoration: none" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              {{ displayUsername }}
              <a-icon type="down" />
            </a>

            <a-menu slot="overlay">
              <a-menu-item key="0">
                <a style="text-decoration: none" @click="handlleLogout">
                  Logout
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-avatar icon="user" />
        </div>
      </a-layout-header>
      <a-layout-content class="container">
        <router-view />

        <!-- <div v-if="showBackOnline">
                   <router-view/>
               </div>
               <div v-else class="center-screen">
                    <a-icon type="api" />
                    <h3>Connect to the internet</h3>
                    <h4>You're offline. Check your connection</h4>
                    <br>
                </div> -->
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Layout",
  data() {
    return {
      agentProfile: {},
      onLine: navigator.onLine,
      showBackOnline: false,
    };
  },
  components: {},
  computed: {
    ...mapGetters(["IsAgentProfileAvailable"]),
    displayUsername() {
      // console.log("IsAgentProfileAvailable | ", this.IsAgentProfileAvailable)
      // let userProfile = JSON.parse(this.IsAgentProfileAvailable)
      return this.agentProfile?.name;
    },
  },
  methods: {
    ...mapActions(["logout"]),
    OnSelect({ key }) {
      // console.log("key |", key)

      this.$router.push(`/${key}`).catch(() => {});
    },
    Onchange(value) {
      this.$router.push(`/${value.key}`).catch(() => {});
    },
    handlleLogout() {
      this.logout();
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
    },
    showSuccessAlert(message) {
      this.$notification["success"]({
        message: message,
      });
    },
    showErrorAlert(message) {
      this.$notification["error"]({
        message: message,
      });
    },

    checkInterConnectivity(isOnLine) {
      //    console.log("isOnLine | ", isOnLine)
      if (isOnLine) {
        this.showBackOnline = true;
        let currentRoute = this.$router.history.current.path;
        // console.log("currentRoute | ", currentRoute)
        this.$router.push(currentRoute).catch(() => {});
      } else {
        this.showBackOnline = false;
        // this.showErrorAlert("Connect to the internet. You're offline. Check your connection");
      }
    },
  },

  created() {
    if (this.IsAgentProfileAvailable) {
      this.agentProfile = this.IsAgentProfileAvailable;
    }
  },
};
</script>

<style scoped>
.ant-layout {
  display: flex;
  flex: auto;
  /* height: 100vh; */
  background: #f0f2f5;
}

.menuIcon {
  font-size: 22px;
}
.ant-layout-sider {
  position: relative;
  min-width: 0;
  background: #FFFFFF;
  transition: all 0.2s;
}

#vueLayout >>> .ant-layout-sider {
  flex: 0 0 220px !important;
  max-width: 230px !important;
  min-width: 210px !important;
  /* width: 230px !important; */
}

.img_size {
  max-width: 75%;
  padding-bottom: 2px;
}
.overview {
  margin-top: 30px;
}
.center-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  font-size: 40px;
}
.retail {
  margin-top: 31px;
  pointer-events: none;
}

.ant-menu {
  box-sizing: border-box;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  margin-bottom: 0;
  padding-left: 16px;
  padding-right: 16px;
  color: #737791;
  line-height: 23px;
  list-style: none;
  background: #FFFFFF;
  outline: none;
  transition: background 0.3s, width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
  zoom: 1;
}

.ant-menu-submenu >>> .ant-menu {
  background-color: #FFFFFF;
  border-radius: 4px;
  color: #737791;
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: #26A246; 
  color: #FFFFFF;
  border-radius: 6px;
  /* padding-top: 4px; */
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item:hover {
  background: #FFFFFF;
  color: #26A246;
}
.ant-menu-submenu-selected {
  color: #737791;
}
/* .subReport:hover{
    color: #737791;
} */


#vueLayout >>> .ant-layout-sider-zero-width-trigger {
  position: absolute;
  top: 64px;
  right: -36px;
  z-index: 1;
  width: 36px;
  height: 42px;
  color: #fff;
  font-size: 18px;
  line-height: 42px;
  text-align: center;
  background: #FFFFFF;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  transition: background 0.3s ease;
}

.subReport >>> .ant-menu-item:active,
.ant-menu-submenu-title:active {
  background: #26A246;
  color: #26A246;
}

#vueLayout >>> .ant-menu-item:hover, .ant-menu-item-active, .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open, .ant-menu-submenu-active, .ant-menu-submenu-title:hover {
    color: #a7243f;
}

.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: none;
}

.ant-menu-inline .ant-menu-selected::after,
.ant-menu-inline .ant-menu-item-selected::after {
  opacity: 0;
}

.subReport > .ant-menu-item:hover, .ant-menu-item-active, .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open, .ant-menu-submenu-active, .ant-menu-submenu-title:hover {
    color:#26A246;
    /* background: #26A246; */
}
.ant-menu-item:hover, .ant-menu-item-active, .ant-menu:not(.ant-menu-inline) .ant-menu-open, .ant-menu-submenu-active, .ant-menu-submenu-title:hover {
    color:#26A246 !important;
} 

.subReport >>> .ant-menu-submenu-title:hover {
    color: #26A246 !important;
}

.subReport >>> .ant-menu-submenu-title:hover > .ant-menu-submenu-arrow::before {
  color: #26A246 !important;
}

/* .subReport >>> .ant-menu-submenu-title .ant-menu-submenu-arrow{
  background: #737791 !important;
}


.subReport >>> .ant-menu-submenu-title:hover, .ant-menu-submenu-arrow::after{
  color: #26A246 !important;
}

.subReport >>> .ant-menu-submenu-title:hover, .ant-menu-submenu-arrow::before{
  color: #737791 !important;
} */


#vueLayout .logo {
  height: 32px;
  margin: 16px;
  font-size: 24px;
  text-align: center;
  line-height: 45px;
  color: #fff;
}

.container {
  margin: 30px auto;
  width: 100%;
}

@media (min-width: 1600px) {
  /* .container {
    margin: 30px auto;
    width: 83%;
  } */
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    max-width: 80%;
  }
}
</style>



